import templateStr from 'text!./templates/pa-vehicle-coverages.html';

export default [function () {
    return {
        template: templateStr,
        scope: {
            vehicles: '=',
            headLabel: '@headLabel'
        },
        link: function link(scope) {
            var selectedVehicle = void 0;

            scope.$watch('vehicles', function (vehicles) {
                if (vehicles && vehicles.length > 0) {
                    selectedVehicle = vehicles[0];
                }
            });

            scope.headLabel = scope.headLabel || {};

            scope.selectedVehicleName = function () {
                if (selectedVehicle) {
                    return selectedVehicle.make + ' ' + selectedVehicle.model;
                }
            };

            scope.setSelectedVehicle = function (vehicle) {
                selectedVehicle = vehicle;
            };

            scope.selectedVehicleClass = function (item) {
                return selectedVehicle === item ? 'gw-light-blue' : null;
            };

            scope.selectedVehicleCoverages = function () {
                if (selectedVehicle && selectedVehicle.coverages) {
                    return selectedVehicle.coverages;
                }
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/directives/PAVehicleCoverages.js
// module id = 1428
// module chunks = 0